module.exports = __webpack_public_path__ + "static/media/grid-img1.58f52775.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid-img1.svg
// module id = 836
// module chunks = 0